import Modal from "react-modal";
import * as S from "./styles";
import Close from "assets/close-small.svg";
import Button from "../../Button";
import { useEffect, useState } from "react";
import {
  geCommentsService,
  Comment,
  saveComment,
} from "services/CommentsService";
import ReactTooltip from "react-tooltip";
interface ModalProps {
  modalIsOpen: boolean;
  setIsOpen: (value: boolean) => void;
  occurrenceId?: string;
  maintenanceId?: string;
}

Modal.setAppElement("#root");

export function CommentsModal({
  modalIsOpen,
  occurrenceId,
  setIsOpen,
  maintenanceId
}: ModalProps) {
  function closeModal() {
    setIsOpen(false);
  }

  const [comments, setComments] = useState<Comment[]>([]);
  const [comment, setComment] = useState("");
  const [id, setId] = useState<string>();
  const [refetch, setRefetch] = useState(false);

  useEffect(() => {
    geCommentsService(occurrenceId ?? maintenanceId!)
      .then((res) => {
        setComments([...res.items]);
      })
      .catch((err) => {
        console.log({ err });
      });
  }, [refetch, occurrenceId, maintenanceId]);

  async function handleComment() {
    await saveComment({
      id,
      content: comment,
      occurrence: occurrenceId,
      maintenance: maintenanceId
    })
      .then((res) => {
        setRefetch(!refetch);
        setComment("");
      })
      .catch((err) => {
        console.log({ err });
      });
  }

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      contentElement={(props, children) => (
        <S.ActiveModalContent {...props}>{children}</S.ActiveModalContent>
      )}
      overlayElement={(props, contentElement) => (
        <S.ActiveModalOverlay {...props}>{contentElement}</S.ActiveModalOverlay>
      )}
    >
      <S.MoreDetailsContent>
        <header>
          <h2>Comentários</h2>
          <S.AlertBadge
            data-for="commentTip"
            data-tip={
              "Para editar um comentário clique nele e digite, caso desista clique em limpar"
            }
            data-iscapture="true"
          >
            <span>?</span>
          </S.AlertBadge>
          <img
            src={Close}
            alt="fechara"
            onClick={closeModal}
            data-cy="close-comments-modal"
          />
        </header>
        <S.ReportContent>
          <S.InputContainer>
            <textarea
              id="description"
              name="description"
              value={comment}
              placeholder="Adicionar comentário..."
              required={true}
              maxLength={1000}
              onChange={(e) => {
                setComment(e.target.value);
              }}
            />
            <div>
              <Button
                title={id ? "Editar" : "Salvar"}
                disabled={comment === ""}
                onClick={async () => {
                  await handleComment();
                }}
              />
              <Button
                title={"Limpar"}
                disabled={!(id || comment !== "")}
                onClick={() => {
                  setComment("");
                  setId(undefined);
                }}
              />
            </div>
          </S.InputContainer>
          <S.CommentsSection>
            {comments.length > 0 ? (
              comments.map((comment) => (
                <span key={comment.id}>
                  <div>
                    <h3>{comment.attendant.name}</h3>
                    <h4>
                      {new Date(comment.createdAt).toLocaleDateString("pt-BR", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </h4>
                    <S.EditButton
                      role="button"
                      onClick={() => {
                        setId(comment.id);
                        setComment(comment.content);
                      }}
                    >
                      Editar comentario
                    </S.EditButton>
                  </div>
                  <p>{comment.content}</p>
                </span>
              ))
            ) : (
              <S.NoComments>Ainda sem comentários...</S.NoComments>
            )}
          </S.CommentsSection>
        </S.ReportContent>
        <ReactTooltip
          id="commentTip"
          place="right"
          type="dark"
          effect="solid"
          className="tooltip"
          backgroundColor={"var(--grey-300)"}
          html
        />
      </S.MoreDetailsContent>
    </Modal>
  );
}
